export enum Status {
  active = "active",
  locked = "locked",
  deleted = "deleted",
}

export enum PageAction {
  add = "Add",
  edit = "Edit",
}
